import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, getEventById, getTimeSlotsByEventId } from "ticketino-api-client";
import axios from "axios";

import Header from './../components/Header'
import Description from './../components/DescriptionDayOfOpenDoors'
import Footer from "./../components/Footer";
import Loading from "./../components/Loading";

const Home = () => {
    const [eventId, setEventId] = useState(0);
    const [theEvent, setTheEvent] = useState({});

    const [timeSlots, setTimeSlots] = useState([]);

    const [orderId, setOrderId] = useState("");

    const [loading] = useState(false);
    const [resources, setResources] = useState({});
    const [openHour, setOpenHour] = useState(null);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);

    const [token, setToken] = useState(sessionStorage.getItem("token"));

    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    const language = "de"; // Default language

    useEffect(() => {
        loadToken();
        requestResources();
    }, []);

    useEffect(() => {
        if (eventId > 0 && token) {
            loadEvent(eventId);
        }
    }, [eventId, token]);

    useEffect(() => {
        if (theEvent?.id) {
            loadTimeSlots(eventId);
        }
    }, [theEvent]);

    const loadToken = () => {
        axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
            setToken(res.data);
            sessionStorage.setItem("token", res.data);
            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            // Use Day of Open Doors ticket type IDs
            setEventId(res.data.eventId_DayOfOpenDoors);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/de`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadEvent = async (eventId) => {
        try {
            const theEvent = await getEventById(eventId);

            const ticketCount = await requestTicketCount(eventId);

            let soldOut = (theEvent.maxTickets - ticketCount) <= 0;

            if (theEvent.status === 0) {
                soldOut = true;
            }

            const eventWithDetails = {
                ...theEvent,
                isSoldOut: soldOut,
                ticketCount: theEvent.maxTickets - ticketCount,
            };

            setTheEvent(eventWithDetails);
        } catch (error) {
            console.error(error);
        }
    };

    const loadTimeSlots = async (eventId) => {
        try {
            let timeslotsByEventIds = [];

            if (theEvent) {
                const timeslotsOfEvent = await getTimeslotsOfEvent(theEvent.id);

                if (timeslotsOfEvent?.length > 0) {
                    const timeslotsWithEventId = timeslotsOfEvent.map((timeslot) => ({
                        ...timeslot,
                        eventId: theEvent.id,
                    }));

                    timeslotsByEventIds = [
                        ...timeslotsByEventIds,
                        ...timeslotsWithEventId,
                    ];
                }
            }

            setTimeSlots(timeslotsByEventIds);
        } catch (error) {
            console.error(error);
        }
    };

    const requestTicketCount = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}/Event/${id}/TicketsSold`);
            return res.data;
        } catch (error) {
            console.error(error);
        }
    };

    const getTimeslotsOfEvent = async (eventId) => {
        let timeslotsByEventId = await getTimeSlotsByEventId(eventId);

        return timeslotsByEventId;
    };

    const mapEventStartTimes = () => {
        const groupedTimeSlots = timeSlots.reduce((acc, timeSlot) => {
            const hour = timeSlot.beginTime.split(':')[0];
            if (!acc[hour]) {
                acc[hour] = [];
            }
            acc[hour].push(timeSlot);
            return acc;
        }, {});

        // Sort the hours
        const sortedHours = Object.keys(groupedTimeSlots).sort((a, b) => a - b);

        return (
            <>
                {sortedHours.map((hour) => (
                    <div key={hour}>
                        <div className="hour-header" onClick={() => toggleHour(hour)}>
                            <span>{groupedTimeSlots[hour][0].beginTime.slice(0, 5)} - {groupedTimeSlots[hour][0].endTime.slice(0, 5)}</span>
                        </div>
                        {openHour === hour && (
                            <div className="time-slot-list">
                                {groupedTimeSlots[hour].sort((a, b) => {
                                    const timeA = a.beginTime.split(':').map(Number);
                                    const timeB = b.beginTime.split(':').map(Number);
                                    return timeA[0] * 60 + timeA[1] - (timeB[0] * 60 + timeB[1]);
                                }).map((timeSlot) => {
                                    const ticketsLeft = Math.max(0, timeSlot.totalAvailableTickets - timeSlot.totalTicketsSold);
                                    const isSlotAvailable = ticketsLeft > 0;

                                    return (
                                        <div
                                            key={timeSlot.timeSlotId}
                                            className={`time-slot ${!isSlotAvailable ? "ticketing-disabled" : ""} ${selectedTimeSlot === timeSlot.timeSlotId ? "selected" : ""}`}
                                            disabled={!isSlotAvailable}
                                            onClick={() => isSlotAvailable && onTimeSlotClick(timeSlot)}
                                        >
                                            <span
                                                className="expanded-timeslot"
                                            >
                                                Startzeit: {timeSlot.beginTime.slice(0, 5)}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                ))}
            </>
        );
    };

    const toggleHour = (hour) => {
        setSelectedTimeSlot(null);
        setOpenHour(openHour === hour ? null : hour);
    };

    const onTimeSlotClick = (timeSlot) => {
        const ticketsLeft = Math.max(0, timeSlot.totalAvailableTickets - timeSlot.totalTicketsSold);
        sessionStorage.setItem("BeginTime", timeSlot.beginTime);
        sessionStorage.setItem("EndTime", timeSlot.endTime);
        sessionStorage.setItem("SlotAvailableTickets", ticketsLeft);
        setSelectedTimeSlot(timeSlot.timeSlotId);
    };

    const handleSubmit = async () => {
        navigate(`/${language}/tag-der-offenen-tuer/ticket`);
    };

    return (
        <div>
            <Header resources={resources} title={resources?.DayOfOpenDoor_HomeTitle} />
            {loading ? (
                <Loading
                    alignment="center"
                    color="#d3d3d3"
                    bgColor="#fff"
                    top="50%"
                />
            ) : (
                <>
                    <div className="container page-container">

                        <div className="mt-4 page-container-smaller">

                            <Description resources={resources} />

                            {/* Ticket Selection Section */}
                            <div className="mt-5 mb-5 buyer-information-box">

                                <p className="subtitle mt-4 mb-5">Wählen Sie hier Ihre Startzeit:</p>
                                <p className="time-slot-date">Sonntag, 20. September 2026</p>

                                <div className="col-md-6">{mapEventStartTimes()}</div>

                                <div className="row mt-5">
                                    <div className="col-6">
                                        <button
                                            className="btn btn-custom btn-next"
                                            onClick={handleSubmit}
                                            disabled={!selectedTimeSlot}
                                        >
                                            {resources?._Next}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )}
        </div>
    )
}

export default Home